import { useState, useEffect, useRef } from 'react';
import { arrow } from '../../ui-icons/icons';
import { UniversalObject } from '../../types/data';

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(' ');
}

const lastTabs = [
  {
    id: NaN,
    Title: 'Сводка',
    index: 1
  },
  {
    id: NaN,
    Title: 'План действий',
    index: 2
  }
];

type TabsListProps = {
  data: UniversalObject[];
  value: UniversalObject;
  isFixed?: boolean;
  onChange: (newValue: UniversalObject) => void;
};

function TabsList({ data, value, isFixed, onChange }: TabsListProps) {
  const tabsRef = useRef<HTMLUListElement | null>(null);
  const [showScrollRight, setShowScrollRight] = useState(false);
  const [showScrollLeft, setShowScrollLeft] = useState(false);

   const currentData = data.concat(lastTabs);

  useEffect(() => {
    const tabsElement = tabsRef.current;

    if (!tabsElement) return;

    const checkOverflow = () => {
      setShowScrollRight(
        tabsElement.scrollWidth > tabsElement.clientWidth &&
          tabsElement.scrollLeft + tabsElement.clientWidth < tabsElement.scrollWidth - 1 && currentData.length > 6
      );
      setShowScrollLeft(tabsElement.scrollLeft > 0);
    };

    checkOverflow();

    window.addEventListener('resize', checkOverflow);
    tabsElement.addEventListener('scroll', checkOverflow);

    return () => {
      window.removeEventListener('resize', checkOverflow);
      tabsElement.removeEventListener('scroll', checkOverflow);
    };
  }, [currentData]);

  const scrollTabs = (direction: number) => {
    const tabsElement = tabsRef.current;

    if (tabsElement) {
      tabsElement.scrollBy({
        left: direction * tabsElement.clientWidth,
        behavior: 'smooth',
      });
    }
  };

  return (
    <div className={`${isFixed && 'sticky top-0 z-20'} relative w-[100%] overflow-x-hidden mb-1 rounded-md bg-white p-1 shadow`}>
      {showScrollLeft && (
        <button
          onClick={() => scrollTabs(-1)}
          className="absolute left-0 top-1/2 -translate-y-1/2 bg-white p-2"
        >
          <div className="rotate-180">
            {arrow}
          </div>
        </button>
      )}

      <ul
        ref={tabsRef}
        aria-label="Tabs"
        className="no-scrollbar flex w-[100%] justify-between space-x-4 overflow-x-auto"
      >
        {currentData.map((tab, index) => (
          <li
            key={index}
            className={classNames(
              value.Title === tab.Title ? 'bg-gray-50 text-darkblue' : 'text-gray-500',
              'cursor-pointer whitespace-nowrap rounded-md px-7 py-3 text-sm font-medium',
            )}
            onClick={() => onChange(tab)}
          >
            {tab.Title}
          </li>
        ))}
      </ul>

      {showScrollRight && (
        <button
          onClick={() => scrollTabs(1)}
          className="absolute right-0 top-1/2 -translate-y-1/2 bg-white p-2"
        >
          <div>
            {arrow}
          </div>
        </button>
      )}
    </div>
  );
}

export default TabsList;
